import styled from "styled-components"

export const MenuIcon = styled.img`
  height: 20px;
  width: 20px;
  filter: invert(54%) sepia(3%) saturate(22%) hue-rotate(1deg) brightness(0%)
    contrast(88%);
`
